import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    Switch,
    FormControlLabel,
    MenuItem,
    Button,
    Divider
} from "@mui/material";
import baseURL from "../../config";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useParams } from "react-router-dom";

const ChargesForm = ({ agentDetails, onSuccess }) => {
    const [formData, setFormData] = useState({
        currency: "USD",
        manningFeeForNewJoinerApplicable: false,
        manningFeeForNewJoiner: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
        manningFeeForRejoinerApplicable: false,
        manningFeeForRejoiner: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
        manningFeeForOwnerProposedApplicable: false,
        manningFeeForOwnerProposed: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
        oneTimeFindesFeeApplicable: false,
        oneTimeFindesFee: 0,
        retentionFeeApplicable: false,
        retentionFee: { amount: 0, perDayOrPerMonth: "perMonth" },
        crewWelfareApplicable: false,
        crewWelfare: { amount: 0, perDayOrPerMonth: "perMonth" },
    });
    const { id } = useParams();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleToggle = (field) => {
        setFormData(prev => ({ ...prev, [field]: !prev[field] }));
    };

    const handleChange = (field, value, subField = null) => {
        if (subField) {
            setFormData(prev => ({
                ...prev,
                [field]: { ...prev[field], [subField]: value }
            }));
        } else {
            setFormData(prev => ({ ...prev, [field]: value }));
        }
    };
    
 

    const handleSubmit = async () => {
        try {
            const token = localStorage.getItem("token"); 
            const urlID = localStorage.getItem("urlID");
             const UserId = localStorage.getItem("user id");

            
            const payload = {
                ...formData,
                crewingAgentId: urlID, // get from selected agent or props
                crewingAgentName: agentDetails?.agentName, 
                creatorId :  UserId,
                creatorName : agentDetails?.agentName  // get from logged-in user
            };

            const res = await axios.post(
                `${baseURL}/api/createChargesForCrewingAgent`, // update baseURL if needed
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            toast.success("Charges saved successfully!");
            console.log("API Response:", res.data);
            onSuccess(res.data);
            window.location.reload();
        } catch (err) {
            console.error("API Error:", err);
            toast.error(err.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <>
            
            <Box sx={{ maxWidth: 900, mx: "auto", mt: 6, px: 2 }}>
                <Card sx={{ p: 3, borderRadius: 3, boxShadow: 4 }}>
                    <CardContent>
                        <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "primary.main" }}>
                            Charges for Crewing Agent
                        </Typography>

                        {/* Currency */}
                        <TextField
                            label="Currency"
                            select
                            value={formData.currency}
                            onChange={(e) => handleChange("currency", e.target.value)}
                            fullWidth
                            margin="normal"
                            sx={{ mb: 3 }}
                        >
                            <MenuItem value="USD">USD</MenuItem>
                            <MenuItem value="EUR">EUR</MenuItem>
                            <MenuItem value="INR">INR</MenuItem>
                        </TextField>

                        <Divider sx={{ my: 2 }} />

                        {/* Manning Fee for New Joiner */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.manningFeeForNewJoinerApplicable}
                                    onChange={() => handleToggle("manningFeeForNewJoinerApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">Manning Fee For New Joiner</Typography>}
                        />
                        {formData.manningFeeForNewJoinerApplicable && (
                            <Grid container spacing={2} mb={3}>
                                {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                                    <Grid item xs={12} sm={4} key={rank}>
                                        <TextField
                                            label={rank}
                                            type="number"
                                            fullWidth
                                            size="small"
                                            value={formData.manningFeeForNewJoiner[rank]}
                                            onChange={(e) => handleChange("manningFeeForNewJoiner", e.target.value, rank)}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Manning Fee for Rejoiner */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.manningFeeForRejoinerApplicable}
                                    onChange={() => handleToggle("manningFeeForRejoinerApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">Manning Fee For Rejoiner</Typography>}
                        />
                        {formData.manningFeeForRejoinerApplicable && (
                            <Grid container spacing={2} mb={3}>
                                {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                                    <Grid item xs={12} sm={4} key={rank}>
                                        <TextField
                                            label={rank}
                                            type="number"
                                            fullWidth
                                            size="small"
                                            value={formData.manningFeeForRejoiner[rank]}
                                            onChange={(e) => handleChange("manningFeeForRejoiner", e.target.value, rank)}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Manning Fee for Owner Proposed */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.manningFeeForOwnerProposedApplicable}
                                    onChange={() => handleToggle("manningFeeForOwnerProposedApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">Manning Fee For Owner Proposed</Typography>}
                        />
                        {formData.manningFeeForOwnerProposedApplicable && (
                            <Grid container spacing={2} mb={3}>
                                {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                                    <Grid item xs={12} sm={4} key={rank}>
                                        <TextField
                                            label={rank}
                                            type="number"
                                            fullWidth
                                            size="small"
                                            value={formData.manningFeeForOwnerProposed[rank]}
                                            onChange={(e) => handleChange("manningFeeForOwnerProposed", e.target.value, rank)}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* One Time Finders Fee */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.oneTimeFindesFeeApplicable}
                                    onChange={() => handleToggle("oneTimeFindesFeeApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">One Time Finders Fee</Typography>}
                        />
                        {formData.oneTimeFindesFeeApplicable && (
                            <TextField
                                label="Amount"
                                type="number"
                                fullWidth
                                margin="normal"
                                size="small"
                                sx={{ mb: 3 }}
                                value={formData.oneTimeFindesFee}
                                onChange={(e) => handleChange("oneTimeFindesFee", e.target.value)}
                            />
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Retention Fee */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.retentionFeeApplicable}
                                    onChange={() => handleToggle("retentionFeeApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">Retention Fee</Typography>}
                        />
                        {formData.retentionFeeApplicable && (
                            <Grid container spacing={2} mb={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Amount"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        value={formData.retentionFee.amount}
                                        onChange={(e) => handleChange("retentionFee", e.target.value, "amount")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        label="Per Day/Per Month"
                                        fullWidth
                                        size="small"
                                        value={formData.retentionFee.perDayOrPerMonth}
                                        onChange={(e) => handleChange("retentionFee", e.target.value, "perDayOrPerMonth")}
                                    >
                                        <MenuItem value="perDay">Per Day</MenuItem>
                                        <MenuItem value="perMonth">Per Month</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        )}

                        <Divider sx={{ my: 2 }} />

                        {/* Crew Welfare */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.crewWelfareApplicable}
                                    onChange={() => handleToggle("crewWelfareApplicable")}
                                />
                            }
                            label={<Typography fontWeight="600">Crew Welfare</Typography>}
                        />
                        {formData.crewWelfareApplicable && (
                            <Grid container spacing={2} mb={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Amount"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        value={formData.crewWelfare.amount}
                                        onChange={(e) => handleChange("crewWelfare", e.target.value, "amount")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        label="Per Day/Per Month"
                                        fullWidth
                                        size="small"
                                        value={formData.crewWelfare.perDayOrPerMonth}
                                        onChange={(e) => handleChange("crewWelfare", e.target.value, "perDayOrPerMonth")}
                                    >
                                        <MenuItem value="perDay">Per Day</MenuItem>
                                        <MenuItem value="perMonth">Per Month</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        )}

                        <Box textAlign="center" mt={4}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                sx={{ px: 5, borderRadius: 2 }}
                                onClick={handleSubmit}
                            >
                                Save Charges
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            <ToastContainer />
        </>
    );
};

export default ChargesForm;
